import React from "react";
import { TextField, IconButton } from "@mui/material";
import { Search } from "@mui/icons-material";

interface Props {
  label: string;
  type?: string;
  value: any;
  onChange?: any;
  helperText?: any;
  error?: boolean;
  hasButton?: boolean;
  buttonIcon?: any;
  onButtonClick?: any;
  required?: boolean;
  name?: string;
  isReadOnly?: boolean;
  multiline?: boolean;
  rows?: number;
  onBlur?: any;
  onlyAllowPostive?: boolean;
}

const CommonTextField = ({
  label,
  type = "",
  value,
  onChange,
  helperText = "",
  error = false,
  hasButton = false,
  buttonIcon = null,
  onButtonClick,
  required = false,
  name = "",
  isReadOnly = false,
  multiline = false,
  rows,
  onBlur,
  onlyAllowPostive = false,
}: Props) => {
  const FieldButton = () => {
    return (
      <IconButton onClick={onButtonClick} color="primary" size="small" edge="end">
        {buttonIcon || "..."}
      </IconButton>
    );
  };

  const textFieldInputProps = { endAdornment: <FieldButton /> };

  return (
    <TextField
      disabled={isReadOnly}
      id={name}
      name={name}
      label={label}
      multiline={multiline || Boolean(rows)}
      rows={rows}
      required={required}
      type={type}
      value={value}
      onChange={(event: any) => {
        if (onlyAllowPostive) {
          if (parseInt(event.target.value) > -1 || event.target.value === "") {
            onChange(event);
          }
        } else {
          onChange(event);
        }
      }}
      onBlur={onBlur}
      helperText={helperText}
      error={error}
      variant="outlined"
      size="small"
      InputLabelProps={{
        shrink: true,
      }}
      InputProps={hasButton ? textFieldInputProps : {}}
      fullWidth
    />
  );
};

export default CommonTextField;
